<div @fadein [@openClose]="!deleted ? 'open' : 'closed'"  class="notification-content" *ngIf="dto">
  <div class="bell">
    <i class="fas fa-bell"></i>
  </div>
  <div class="notification-title">
    <div class="notification-icon">
          <span class="icon">
                <i class="fas fa-calendar"></i>
          </span>
      <div class="title">&nbsp;&nbsp;{{dto.appointment.title}}</div>
    </div>
  </div>
  <div class="notification-dueTime"> {{getDueTime()}} </div>
  <div class="description">
    <p class="notes">{{getNotes()}}</p>
    <p class="notes" [innerHtml]="getReminder()"></p>
  </div>
  <div class="buttons">
    <button pButton (click)="dismiss()">Dismiss</button>
    <button pButton *ngIf="showSnooze()" (click)="snooze()">Snooze</button>
  </div>
  <audio src="assets/ding-dong.mp3" preload="none" autoplay></audio>
</div>
